








import { mapGetters } from 'vuex'
import { format } from '~/utils/date'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    userSince: {
      validator: prop =>
        typeof prop === 'number' || typeof prop === 'string' || prop === null,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerIsConstructionCompany: 'sellerIsConstructionCompany'
    }),
    ...mapGetters({
      isPlotClassified: 'classifieds/view/isPlotClassified'
    }),
    sinceLabel() {
      if (this.sellerIsConstructionCompany) {
        return this.$t('construction company in plot.gr since')
      } else if (this.isPlotClassified) {
        return this.$t('agent in plot.gr since')
      } else {
        return this.$t('dealer in car.gr since')
      }
    },
    formatedUserSince() {
      return format(this.userSince, 'dd-MM-yyyy', { locale: this.$i18n.locale })
    }
  }
})
